/* ============================================================
   melusio-notify.js — notify-me overlay enhancement (Cut 3).

   The drop pills are real <a href="#famistas"> links; JS upgrades them to open
   the shared notify overlay and stamps the hidden contact[tags] with the clicked
   teaser's handle (notify-{handle}). The form POSTS NATIVELY — nothing here fetches.

   Shopify renders form.posted_successfully? on EVERY {% form 'customer' %} on the
   page (a documented multi-form limitation), so we can't tell server-side which
   form posted. We disambiguate on the client with a sessionStorage flag written at
   submit time: reopen the notify overlay only if IT was submitted, and show the
   footer newsletter's result line only if THAT form was submitted.
   ============================================================ */
(function () {
  const overlay = document.getElementById('melusio-notify');
  const KEY_NOTIFY = 'melusio-notify-posted';
  const KEY_NEWSLETTER = 'melusio-newsletter-posted';
  const newsletterForm = document.getElementById('melusio-footer-newsletter');

  const flag = (key) => { try { sessionStorage.setItem(key, '1'); } catch (_) {} };
  const takeFlag = (key) => {
    let v = false;
    try { v = sessionStorage.getItem(key) === '1'; sessionStorage.removeItem(key); } catch (_) {}
    return v;
  };

  // ---- pill → open overlay + stamp the teaser tag ----
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-notify-piece]');
    if (!pill || !overlay) return;
    e.preventDefault(); // pill is an <a href="#famistas"> no-JS fallback
    const handle = pill.getAttribute('data-notify-piece');
    const tagInput = overlay.querySelector('[data-notify-tag]');
    if (tagInput && handle) tagInput.value = 'notify-' + handle;
    if (window.MelusioOverlay) window.MelusioOverlay.open('melusio-notify', pill);
  });

  // ---- flag native submits so we know which customer form actually posted ----
  const notifyForm = overlay && overlay.querySelector('form');
  if (notifyForm) notifyForm.addEventListener('submit', () => flag(KEY_NOTIFY));
  if (newsletterForm) newsletterForm.addEventListener('submit', () => flag(KEY_NEWSLETTER));

  // ---- on load: reveal the result of whichever form the user submitted ----
  function onReady() {
    const notifyPosted = takeFlag(KEY_NOTIFY);
    const newsletterPosted = takeFlag(KEY_NEWSLETTER);

    // The server printed a result into every customer form; keep it only where it belongs.
    if (!newsletterPosted && newsletterForm) {
      newsletterForm.querySelectorAll('[data-newsletter-result]').forEach((el) => el.remove());
    }

    if (notifyPosted && overlay && window.MelusioOverlay) window.MelusioOverlay.open('melusio-notify');
  }
  if (document.readyState !== 'loading') onReady();
  else document.addEventListener('DOMContentLoaded', onReady);
})();
